import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter, Router, RouterProvider} from "react-router-dom";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
    {
        path: "/",
        element: <App/>,
        ErrorBoundary: () => <App/>,
    },
    {
        path: "/character/:id",
        element: <App/>,
        ErrorBoundary: () => <App/>,
    },
    {
        path: "/spell/:id",
        element: <App/>,
        ErrorBoundary: () => <App/>,
    },
    {
        path: "/item/:id",
        element: <App/>,
        ErrorBoundary: () => <App/>,
    },
]);

root.render(
    //<React.StrictMode>
    <RouterProvider router={router} />
    //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
